import type { FunctionComponent } from "react";

export const RaiffeisenImpulsDeLogo: FunctionComponent = () => {
  return (
    <a href={"https://www.ril-fuhrpark.de/de/ueber-uns.html"} className={"flex"}>
      <img
        src="/images/brand/raiffeisen-impuls-leasing-de.svg"
        className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
        alt="Raiffeisen-IMPULS"
      />
    </a>
  );
};
